import { cn } from '@/ui/lib/utils';
import './menuIcon.css';

interface MenuIconProps {
    isOpen: boolean;
    className?: string;
}

export const MenuIcon = ({ isOpen, className }: MenuIconProps) => {
    return (
        <div className={cn('menu-icon', isOpen && 'menu-icon--open')} aria-label="Toggle menu">
            <svg
                className={cn('menu-icon__svg', className)}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
            >
                <rect
                    className="menu-icon__bar menu-icon__bar--top"
                    width="21"
                    height="2"
                    rx="1"
                    fill="white"
                />
                <rect
                    className="menu-icon__bar menu-icon__bar--middle"
                    y="6"
                    width="14"
                    height="2"
                    rx="1"
                    fill="white"
                />
                <rect
                    className="menu-icon__bar menu-icon__bar--bottom"
                    y="12"
                    width="9"
                    height="2"
                    rx="1"
                    fill="white"
                />
            </svg>
        </div>
    );
};
